
window.addEventListener('DOMContentLoaded', () => {
  // 라이브러리 존재 여부 확인
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('Required libraries (GSAP, ScrollTrigger) not loaded for services section');
    return;
  }


  // DOM 요소 캐싱 및 존재 여부 확인
  const $homeServices = document.getElementById('homeServices');
  if (!$homeServices) return;

  const $serviceItems = $homeServices.querySelectorAll('.service-item');
  const $moreSection = $homeServices.querySelector('.more');

  // 필수 요소 존재 확인
  if (!$serviceItems.length) {
    console.warn('Service items not found for services animation');
    return;
  }

  // 접근성을 위한 간소화된 초기화
  if (window.prefersReducedMotion) {
    // 애니메이션 비활성화 시 즉시 표시
    $serviceItems.forEach(item => {
      item.style.opacity = '1';
      item.style.transform = 'translateY(0)';
    });
    if ($moreSection) {
      $moreSection.style.opacity = '1';
      $moreSection.style.transform = 'translateY(0)';
    }
    return;
  }

  try {
    // 초기 상태 설정
    gsap.set($serviceItems, {
      y: 60,
      opacity: 0
    });

    if ($moreSection) {
      gsap.set($moreSection, {
        y: 40,
        opacity: 0
      });
    }

    // ScrollTrigger 애니메이션
    ScrollTrigger.create({
      trigger: $homeServices.querySelector('.services'),
      start: 'top 80%',
      end: 'bottom bottom',
      once: true,
      onEnter: () => {
        // 서비스 아이템 순차 애니메이션
        gsap.to($serviceItems, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power2.out',
          stagger: 0.2
        });

        // More 섹션 애니메이션 (딜레이 후)
        if ($moreSection) {
          gsap.to($moreSection, {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: 'power2.out',
            delay: 0.6
          });
        }
      }
    });

  } catch (error) {
    console.warn('Services animation setup failed:', error);
    // 에러 시 즉시 표시
    $serviceItems.forEach(item => {
      item.style.opacity = '1';
      item.style.transform = 'translateY(0)';
    });
    if ($moreSection) {
      $moreSection.style.opacity = '1';
      $moreSection.style.transform = 'translateY(0)';
    }
  }

});